import React from "react";
import { cn } from "../../../lib/utils";

/**
 * The admin page header (BookingsAdmin, Overview): `h1.font-display.text-4xl.text-eh-ink`,
 * an optional muted subtitle, and the page's actions on the right (wrapping on phones).
 */
export default function CrmPageHeader({ title, subtitle, actions, children, className, testId }) {
  return (
    <header className={cn("flex flex-wrap items-end justify-between gap-3 mb-6", className)} data-testid={testId}>
      <div>
        <h1 className="font-display text-4xl text-eh-ink">{title}</h1>
        {subtitle && <p className="text-eh-muted text-sm mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      {children}
    </header>
  );
}
